import { Outlet, ScrollRestoration } from "react-router-dom";
import NavbarLayout from "./components/memberLayout/navbarLayout";
import Container from "@/components/container";

const AppLayout = () => {
  return (
    <main className="min-h-screen">
      <ScrollRestoration />
      <Container>
        <NavbarLayout />
      </Container>
      <Container>
        <Outlet />
      </Container>
    </main>
  );
};

export default AppLayout;
